import escapeStringRegexp from 'escape-string-regexp';

function search(options, query, showHighlights = false) {
  // Query Options that begin with given query
  const queryStr = `(${escapeStringRegexp(query)})`;
  const reg = new RegExp(queryStr, 'i');
  // Filter matching results
  const result = options.filter(opt => reg.test(opt.optLabel));
  if (showHighlights) {
    return result.map(opt => ({
      optLabel: opt.optLabel.replace(reg, '<b>$1</b>'),
      optValue: opt.optValue,
      exactMatch: opt.optLabel === query
    }));
  }
  return result;
}

export default search;
